import { Buffer } from 'buffer';

function btoa(str) {
  return Buffer.from(str, 'binary').toString('base64');
}
function atob(str) {
  return Buffer.from(str, 'base64').toString('binary');
}
function encodeString(str) {
  return btoa(encodeURIComponent(str));
}
function decodeString(base64Str) {
  return decodeURIComponent(atob(base64Str));
}

export { atob, btoa, decodeString, encodeString };
